import { GeneratedReportFile } from "../constants/types";

export const downloadReportFile = (file: GeneratedReportFile) => {
  const blob = new Blob([file.content], { type: file.mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.suggestedFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
